import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import { AccountOverview, TotpEnrolment } from './_models'

export const ACCOUNT_URL = `${API_URL}/api/internal/account`

type WithPassword = { currentPassword: string }

export const getAccount = () => axios.get<ApiResponse<AccountOverview>>(ACCOUNT_URL)

export const changePassword = (currentPassword: string, newPassword: string) =>
  axios.post<ApiResponse<Record<string, never>>>(`${ACCOUNT_URL}/password`, { currentPassword, newPassword })

export const startTotp = (currentPassword: string) =>
  axios.post<ApiResponse<TotpEnrolment>>(`${ACCOUNT_URL}/totp/start`, { currentPassword } as WithPassword)

export const confirmTotp = (code: string) =>
  axios.post<ApiResponse<{ recoveryCodes: string[] }>>(`${ACCOUNT_URL}/totp/confirm`, { code })

export const getPasskeyCreationOptions = (currentPassword: string) =>
  axios.post<ApiResponse<{ options: any }>>(`${ACCOUNT_URL}/passkey/options`, { currentPassword } as WithPassword)

export const addPasskey = (attestation: Record<string, unknown>, name: string) =>
  axios.post<ApiResponse<AccountOverview>>(`${ACCOUNT_URL}/passkey`, { attestation, name })

export const removePasskey = (id: number, currentPassword: string) =>
  axios.post<ApiResponse<AccountOverview>>(`${ACCOUNT_URL}/passkey/${id}/remove`, { currentPassword } as WithPassword)

export const reissueRecoveryCodes = (currentPassword: string) =>
  axios.post<ApiResponse<{ recoveryCodes: string[] }>>(`${ACCOUNT_URL}/recovery-codes`, { currentPassword } as WithPassword)

export const disableSecondFactor = (currentPassword: string) =>
  axios.post<ApiResponse<AccountOverview>>(`${ACCOUNT_URL}/second-factor/disable`, { currentPassword } as WithPassword)
